import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BufferService, LoadingContext } from '../M_Components'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { Tag } from 'primereact/tag'

export default function LogsPage() {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const [dataPatchNotes, setDataPatchNotes] = useState([])
    const [activeIndex, setActiveIndex] = useState(null)
    const bufferServicePatchNotes = new BufferService('ChangeLog')

    const changeTypeMap = {
        0: { label: t('Added'), severity: 'success' },
        1: { label: t('Changed'), severity: 'warning' },
        2: { label: t('Fixed'), severity: 'danger' }
    }


    useEffect(() => {
        bufferServicePatchNotes.get().then((response) => {

            const groupedByVersion = Object.values(
                response.Items.reduce((value, item) => {
                    if (!value[item.Version]) {
                        value[item.Version] = {
                            version: item.Version,
                            updateDate: item.UpdateDate,
                            items: []
                        }
                    }

                    value[item.Version].items.push(...item.Items)
                    return value
                }, {})
            )
            setDataPatchNotes(groupedByVersion)
        })
    }, [])

    useEffect(() => {
        if (dataPatchNotes.length > 0) {
            setActiveIndex(0)
        }
    }, [dataPatchNotes])

    return (
        <div className="divGlobalSettings">
            <div className="subTitleSettings">
                <div>
                    <div style={{ color: ctx.secondaryColor }} >
                        {t("PatchNotes")}
                    </div>
                    <div className="labelSubtitleSettings" >
                        {t("InfoPatchNotes")}
                    </div>
                </div>
            </div>

            <div>
                <Accordion
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                >
                    {dataPatchNotes.map((patch, index) => (
                        <AccordionTab
                            key={patch.version}
                            header={
                                <div className="patchNotesVersion">
                                    <div><b>{t("Version")}: </b>{patch.version}</div>
                                    <div><b>{t("ReleaseDate")}: </b><em>{new Date(patch.updateDate).toLocaleDateString()}</em></div>
                                </div>
                            }
                        >
                            <ul>
                                {patch.items.map((item, itemIndex) => {
                                    const changeType = changeTypeMap[item.Type]

                                    return (
                                        <li key={itemIndex} className="patchNoteItem">
                                            <Tag
                                                className="patchTag"
                                                severity={changeType?.severity}
                                                value={changeType?.label}
                                            />

                                            <span style={{ marginLeft: 8 }}>
                                                {item.Description}
                                            </span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </AccordionTab>
                    ))}
                </Accordion>
            </div>
        </div>
    )
}
